export enum WorkloadTypeEnum {
  Employee = 'employee',
  BusinessArea = 'businessArea',
  Project = 'project'
}
